window.addEventListener('DOMContentLoaded', _ => {
  const state = []
  const containers = document.querySelectorAll('.counters')

  if ( containers.length > 0 ) {
    containers.forEach(createState)
  }

  function createState(container, index) {
    const opt = {
      root: null,
      rootMargin: "0px",
      threshold: 0.8
    }
  
    const o = new IntersectionObserver(entries => intersected(entries, index), opt)
  
    state[index] = {
      hasBeenSeen: false,
      container: container,
      counters: container.querySelectorAll('.counter'),
      observer: o.observe(container)
    }
  }

  function intersected(entries, index) {
    const [ entry ] = entries
  
    if ( entry.isIntersecting && !state[index].hasBeenSeen ) {
      state[index].hasBeenSeen = true
  
      state[index].counters.forEach(counter => {
        let base = parseInt(counter.dataset.start)
        const end = parseInt(counter.dataset.end)
        const step = parseInt(counter.dataset.step)
        const number = counter.querySelector('span.counter__number')
  
        const i = setInterval(() => {
          base += step          
          number.textContent = base.toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  
          if ( base >= end ) {
            clearInterval(i)
          }
        }, 20)
      })
    }
  }
})